// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceChannelId } from './DeviceChannel';
import { deviceId } from './Device';
import { z } from 'zod';
export const deviceCounterSnapshot = z.object({
    channel_id: deviceChannelId,
    device_id: deviceId,
    value: z.string().nullable(),
    reported_epoch: z.number().nullable(),
    last_reading_at: z.date().nullable(),
    updated_at: z.date(),
});
export const deviceCounterSnapshotInitializer = z.object({
    channel_id: deviceChannelId,
    device_id: deviceId,
    value: z.string().optional().nullable(),
    reported_epoch: z.number().optional().nullable(),
    last_reading_at: z.date().optional().nullable(),
    updated_at: z.date().optional(),
});
export const deviceCounterSnapshotMutator = z.object({
    channel_id: deviceChannelId.optional(),
    device_id: deviceId.optional(),
    value: z.string().optional().nullable(),
    reported_epoch: z.number().optional().nullable(),
    last_reading_at: z.date().optional().nullable(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=DeviceCounterSnapshot.js.map